import React, { useContext, useState, useEffect } from 'react';
import { Button } from 'antd';
import { ModalContext } from 'context/ModalContext';
import { DashboardContext } from 'context/DashboardContext';
import AddClientRecommendation from 'components/widgets/modals/AddClientRecommendation';
import AddClientRiskModal from 'components/widgets/modals/AddClientRisk';
import AddClientProductBenefit from 'components/widgets/modals/AddClientProductBenefit';
import { useParams } from 'react-router-dom';
import { view_client_quotation,  list_client_quotation_risks, list_guest_client_recommendations, sendQuotationToGuestClient  } from 'services/apiSrv';
import { formatDate } from 'utils/helpers';
import { useQuery } from 'react-query';
import { file_url } from 'services/apiSrv';
import { useQueryClient } from 'react-query';


function SingleClientQuotation(props) {
    const { setModalShow, modalShow, modalClose } = useContext(ModalContext);
    const { prodId, setProductId, ref, setRef } = useContext(DashboardContext);
    const [selectedRec, setSelectedRec] = useState("")
    console.log({prodId, ref})
    const { id } = useParams();
    const queryClient = useQueryClient();

    const [quotation, setQuotation] = useState(null);
    const [error, setError] = useState(null);
    const [isSendLoading, setIsSendLoading] = useState(false);

 
    const { data, isLoading, error: ferr } = useQuery({
        queryKey: ['list_client_quotation_risks', id], // Unique key for caching
        queryFn: () => list_client_quotation_risks(id),
        enabled: !!id, // Only run query if id exists
      });


      const { data: recommendations, isLoading: isRecLoading, error: recError } = useQuery({
        queryKey: ['guestClientRecommendations', id], // Unique key for caching
        queryFn: () => list_guest_client_recommendations(id),
        enabled: !!id, // Only run query if id exists
      });

      let quotation_reccomendation = recommendations?.recommendations
      console.log("recommendations===", quotation_reccomendation)

    // useEffect(() => {
    //     const fetchQuotation = async () => {
    //     try {
    //         const response = await view_client_quotation(id);
    //         setQuotation(response);
    //     } catch (err) {
    //         setError(err.message || 'Error fetching quotation');
    //         console.error('Error:', err);
    //     }
    //     };

    //     if (id) {
    //     fetchQuotation();
    //     }
    // }, [id]); // Re-run if ID changes

    const { data: quotationData, isLoading: isQuotationLoading, error: quotationError } = useQuery({
        queryKey: ['view_client_quotation', id], // Unique key for caching
        queryFn: () => view_client_quotation(id),
        enabled: !!id, // Only run query if id exists
        onSuccess: (response) => {
            setQuotation(response); // Update state with fetched data
        },
        });

    if (error) {
        return <div>Error: {error}</div>;
    }

    if (!quotation) {
        return <div>Loading...</div>;
    }

    const { draft_quotation } = quotation;
    console.log("TTIID====", draft_quotation)


    const updatedRisks = data?.risks?.map((risk) => {
        const formItem = risk.risk_form?.find((item) => item.name === 'SSF00013724');
        return {
            ...risk,
            name: formItem?.value || 'Unnamed Risk',
        };
    }).filter((risk) => risk.name !== 'Unnamed Risk');;

   console.log("DRAFT RISK===", updatedRisks)

   const handleRiskAdded = () => {
        queryClient.invalidateQueries(['list_client_quotation_risks', id]);
    };

   const handleSend = async () => {
        setIsSendLoading(true);
        setModalShow(true); // Show the modal
        try {
          const response = await sendQuotationToGuestClient(id);
          await queryClient.invalidateQueries(['view_client_quotation', id]);
        } catch (error) {
          console.error("Failed to send quotation:", error);
        } finally {
            setIsSendLoading(false);
        }
      };

        const handleOnRec = () => {
        queryClient.invalidateQueries(['guestClientRecommendations', id]);
        queryClient.invalidateQueries(['view_client_quotation', id]);
        };
    return (
        <div>
            <AddClientRecommendation onRecommendationAdded={handleOnRec} risks={data?.risks} client_quotation_id={id} show={modalShow === 'recommendation'} onHide={modalClose} />
            <AddClientRiskModal onRiskAdded={handleRiskAdded} client_quotation_id={id} show={modalShow === 'risk'} onHide={modalClose} />
            { (<AddClientProductBenefit
            //  guest_client_quotation_id={draft_quotation?.guest_client_recommendation_id}
            guest_client_quotation_id={selectedRec}
             show={modalShow === "benefits" ? true : false}  
             onHide={() => {
                  modalClose();
                }} 
            />)}

            <div className="card mr-8 my-4 shadow-sm px-12" >
                <div className="card-body mx-auto" style={{ maxWidth: '1000px' }}>
                    <h5 className="card-title mb-4 fw-semibold">Insurance Details</h5>
                    <div className="row gy-3">
                        <div className="col-md-6">
                            <strong>Insurance Class:</strong> <div>{draft_quotation.insurance_class_details.name}</div>
                        </div>
                        <div className="col-md-6">
                            <strong>Client Name:</strong> <div>{draft_quotation.client_names}</div>
                        </div>
                        <div className="col-md-6">
                            <strong>Client Email:</strong> <div>{draft_quotation.client_email}</div>
                        </div>
                        <div className="col-md-6">
                            <strong>Cover Type:</strong> <div>{draft_quotation.cover_type.name}</div>
                        </div>
                        <div className="col-md-6">
                            <strong>Status:</strong>
                            <div>
                                <span className="badge bg-success">{draft_quotation.status}</span>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <strong>Reference:</strong> <div>{draft_quotation.guest_client_quotation_ref}</div>
                        </div>
                        <div className="col-md-6">
                            <strong>Created Date:</strong> <div>{formatDate(draft_quotation?.createdAt)}</div>
                        </div>
                        
                        <div className='d-flex'>
                         
                         <div className='py-4 px-3 w-50'>
                           <strong> Risk(s)</strong>

                        {updatedRisks && updatedRisks.map((item, index) => (
                            <div>{item.name}</div>
                        )) }
                         </div>

                        <div className="py-4 px-3 bg-light w-50 d-flex">
                            {/* <Button
                                className="btn-blue text-white rounded float-right mb-3 mx-2"
                                onClick={() => {
                                    setModalShow(true)
                                    sendQuotationToGuestClient(id)
                                
                                }} // Unchanged for now
                            >
                                Send To Client
                            </Button> */}
                            <Button
                           className={`${
                            draft_quotation.status.toLowerCase() !== "sent" ? "btn-blue" : "btn-gray"
                            } text-white rounded float-right mb-3 mx-2`}
                                                        
                            onClick={handleSend}
                            disabled={isSendLoading || recommendations?.recommendations?.length === 0 || draft_quotation.status.toLowerCase() === "sent"}
                            >
                            {isSendLoading ? "Sending..." : "Send To Client"}
                            </Button>
                            <Button
                                className="btn-blue text-white rounded float-right mb-3 mx-2"
                                onClick={() => setModalShow('risk')}
                            >
                                Add Risk
                            </Button>
                            <Button
                                className="btn-blue text-white rounded float-right mb-3 mx-2"
                                onClick={() => setModalShow('recommendation')}
                                disabled={data?.risks.length === 0}
                            >
                                Add Recommendation
                            </Button>
                        </div>
                        </div>

                    </div>
                    {quotation_reccomendation &&
                            quotation_reccomendation.map((item, index) => (
                        <div className="row g-2 border-4 mb-4 bg-light" key={index} style={{ height: "300px" }}>
                        <div className="col-md-8 p-4">
                            <h5 className="fw-semibold">{item.product.product_name}</h5>
                            <p className="mb-1">
                            <strong>Premium:</strong> {item.premium_amount}
                            </p>
                            <p className="mb-3">
                            <strong>Currency Level:</strong> {item.preferred_currency}
                            </p>
                            <div className="mb-3">
                            <h6 className="fw-semibold mb-1">Remarks</h6>
                            <p className="mb-0 text-muted">{item.recommendation_remarks}</p>
                            </div>
                            <div>
                            <h6 className="fw-semibold mb-1">Benefits</h6>
                            <>

                                {item?.benefit_details?.map((benefit) => (
                                <ul className="mb-0 text-muted" key={benefit.id}>
                                    <li>
                                    {benefit.name}
                                    </li>
                                </ul>
                                )) || <p>No benefits available</p>}
                            
                            <Button
                                className="btn-blue text-white rounded float-right mb-3 mx-2"
                                onClick={() => {
                                    setModalShow('benefits')
                                    setProductId(item.product_id)
                                    setSelectedRec(item?.guest_client_recommendation_id)
                                    setRef(item?.guest_client_quotation_recommendation_ref)
                                }}
                                disabled={data?.risks.length === 0}
                            >
                                Add Benefit
                            </Button>    
                            </>
                            </div>
                        </div>

                        <div className="col-md-4 p-0">
                            <img
                            src={`${file_url}${item?.product?.logo}`}
                            className="w-100 h-100 rounded-end"
                            style={{ objectFit: "cover" }}
                            alt="Super Health Plan"
                            />
                        </div>
                        </div>

                            ))}
                </div>
            </div>
        </div>
    );
}

export default SingleClientQuotation;